import { SignCloudinaryUploadInput, SignCloudinaryUploadOutput } from '@creative-kit/shared';
import { fn } from 'firebase-modules';
import { FirebaseFunction } from './utils';

export const signCloudinaryUpload: FirebaseFunction<
  SignCloudinaryUploadInput,
  SignCloudinaryUploadOutput
> = fn.httpsCallable('signCloudinaryUpload');
